import React from "react";
import "../styles/CustomSelector.css";

export default function CustomSelector({
  onSelect,
  style,
  children,
  isActive,
  disable,
}) {
  return (
    <div
      className={`${"custom-selector-container"} ${
        isActive
          ? "custom-selector-active"
          : disable
          ? "custom-selector-disable"
          : ""
      }`}
      onClick={!disable ? onSelect : null}
      style={style}
    >
      {children}
    </div>
  );
}
